export default "__VITE_ASSET__c4942b96__"